const geometry = require("./geometry");
const utils = require("./utils");

/**
 *
 * @param {google.maps.Map|BMap.Map} map
 * @param {geometry.Point} coord
 * @private
 * @returns {geometry.Point}
 * @memberOf woosmap.maps.coordinates
 */
function getPixelCoordinates(map, coord) {
    const zoom = map.getZoom();

    const scale = 1 << zoom;
    const projection = map.getProjection();

    const worldCoordinate = projection.fromLatLngToDivPixel(coord);
    return new geometry.Point(worldCoordinate.x * scale, worldCoordinate.y * scale);
}
/**
 *
 * @param {google.maps.Map|BMap.Map} map
 * @param {geometry.Point} coord
 * @private
 * @returns {*}
 * @memberOf woosmap.maps.coordinates
 */

function getTileCoordinates(map, coord, options) {
    options = options || {};
    const tileSize = options.tileSize || 256;
    const pixelCoord = getPixelCoordinates(map, coord);
    const point = new geometry.Point(Math.floor(pixelCoord.x / tileSize), Math.floor(pixelCoord.y / tileSize));
    console.log(point);
    return point;
}

module.exports = {
    getTileCoordinates,
    getPixelCoordinates,
};
